import { Divider, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import Smartphone from '../../../assets/icons/Smartphone.svg'
import TelegramDark from '../../../assets/icons/TelegramDark.svg'
import {useSearchParams} from "react-router-dom";

export const TelegramWidget = ({ onClick, disabled }) => {
    const { breakpoints, palette } = useTheme()
    const [searchParams, setSearchParams] = useSearchParams()

    const isMobile = useMediaQuery(breakpoints.down('md'))
    const handleClick = (tab) => {
        searchParams.set('tab', tab)
        setSearchParams(searchParams)
        onClick()
    }

    return (
        <Stack
            spacing={1}
            direction="row"
            sx={{
                alignItems: 'center',
                background: disabled ? '#7f7f7f' : '#FFF',
                opacity: disabled ? '0.5' : '1',
                position: 'relative',
                cursor: 'pointer',
                p: isMobile ? '5px 6px' : '6px 12px',
                borderRadius: '99px',
                zIndex: 0,
                '&:hover': {
                    borderRadius: '99px',
                },
                '&:after': {
                    pointerEvents: 'none',
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    zIndex: -1,
                    borderRadius: 'inherit',
                },
            }}>
            <Stack direction="row" onClick={()=>handleClick(0)} spacing={1} sx={{ alignItems: 'center' }}>
                <Smartphone />
                <Stack direction="column">
                    <Typography variant="caption2" color={palette.text.primary}>
                        Приложение
                    </Typography>
                    <Typography variant="caption4" color="#5E626E">
                        {/* iOS и  */}
                        Android
                    </Typography>
                </Stack>
            </Stack>
            <Divider orientation="vertical" flexItem />
            <TelegramDark onClick={()=>handleClick(1)} />
        </Stack>
    )
}
